module.exports = __webpack_public_path__ + "static/media/5.258f62ac.svg";